import owd from 'owd/owd';

export default class PlayVideo extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
		this.on('resize load ajaxload', this.dom.$window, () => {
			this.$element.inview(() => {
				this.$element[0].play();
			}, () => {
				this.$element[0].pause();
			});
		});
	}
}

owd.registerComponent('play-video', {
	component: PlayVideo
});
